'use client';

import { type FC } from 'react';
import { motion } from 'motion/react';
import Image from 'next/image';
import { cn } from '@spellix/theme';
import { Button, Divider } from '@spellix/ui';
import { Link } from '@repo/i18n';
import { WEB_ROUTE_PATHS } from '@repo/routing';
import { HEADER_EASING, HEADER_INITIAL_WIDTH, HEADER_MAX_WIDTH } from '@/modules/layout/constants';
import { useHeaderScrolled } from '@/modules/layout/hooks';
import { HeaderNavigation } from './header-navigation';

export const Header: FC = () => {
  const { hasScrolled } = useHeaderScrolled();

  return (
    <>
      <motion.header
        className={cn(
          'flex z-50 justify-center transition-all duration-300',
          hasScrolled ? 'sticky top-4 mx-5 lg:mx-4 xl:mx-2' : 'top-0 mx-0',
        )}
      >
        <motion.div
          initial={{ width: HEADER_INITIAL_WIDTH }}
          animate={{ width: hasScrolled ? HEADER_MAX_WIDTH : HEADER_INITIAL_WIDTH }}
          transition={{ duration: 0.3, ease: HEADER_EASING }}
        >
          <div
            className={cn(
              'mx-auto max-w-7xl rounded-2xl transition-all duration-300',
              hasScrolled ? 'px-2 border backdrop-blur-lg border-border bg-neutral-900/75' : 'px-6 shadow-none',
            )}
          >
            <div
              className={cn('flex gap-4 justify-between items-center p-4 px-6', hasScrolled ? 'h-[56px]' : 'h-[64px]')}
            >
              <Link href={WEB_ROUTE_PATHS.home()} className="flex flex-shrink-0 gap-3 items-center">
                <Image src="/logo.svg" alt="logo" width={108} height={24} />
              </Link>
              <HeaderNavigation />
              <div className="flex flex-row gap-1 items-center md:gap-3 shrink-0">
                <div className="flex items-center space-x-6">
                  <Button asChild variant="filled" color="primary" size="sm">
                    <Link href="#">Try for free</Link>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </motion.header>
      <Divider
        className={{
          root: cn(
            '!absolute top-[64px] w-full transition-all duration-100',
            hasScrolled ? 'opacity-0' : 'opacity-100',
          ),
        }}
      />
    </>
  );
};
